import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { RestCallerService } from '../common/services/rest-caller.service';

declare var $: any;
declare var swal: any;
declare var alasql: any;

@Component({
    selector: 'app-client-management',
    templateUrl: './client-management.component.html',
    styleUrls: ['./client-management.component.css']
})

export class ClientManagementComponent implements OnInit, OnDestroy {
    addClientForm: FormGroup;
    deactivateClientForm: FormGroup;
    reactivateClientForm: FormGroup;
    updateClientForm: FormGroup;

    clientList: any;
    filteredClientList: any;
    clientTableFilterValue: string;
    showLoader = false;

    constructor(private restCallingService: RestCallerService) { }


    //#region LifeCycle Hooks

    ngOnInit() {
        this.addClientForm = new FormGroup({
            'payerID': new FormControl()
        });
        this.deactivateClientForm = new FormGroup({
            'payerID': new FormControl()
        });
        this.reactivateClientForm = new FormGroup({
            'payerID': new FormControl()
        });
        this.updateClientForm = new FormGroup({
            'payerId': new FormControl(),
            'emailOptIn': new FormControl(),
            'clientActive': new FormControl()
        });


        $('#addClientButton').on('click', function () {
            $('#addClientSection').slideToggle();
            $('.add-client-icon').toggleClass('fa-plus-circle fa-minus-circle');
        });
        $('#activateClientButton').on('click', function () {
            $('#activateClientSection').slideToggle();
            $('.activate-client-icon').toggleClass('fa-plus-circle fa-minus-circle');
        });

        $('#client-mgmt').addClass('active');
    }

    ngOnDestroy() {
        $('.nav>li.active').removeClass('active');
    }

    //#endregion

    //#region Page Events

    addNewClient() {
        let s: string = this.addClientForm.value["payerID"];
        this.addClientForm.patchValue({payerID: s.toUpperCase()});
        if (this.addClientForm.value['payerID'] !== null) {
            this.showLoader = true;
            this.restCallingService.addClient(this.addClientForm.value['payerID']).subscribe(
                data => {
                    this.showLoader = false;
                    this.resetFormValues();
                    swal('Success!', 'Client Created Successfully!', 'success');
                },
                err => {
                    this.showLoader = false;
                    console.log(err.json());
                    swal('Failure', err.json().message, 'error');
                });
        } else {
            swal('Failure', 'Invalid PayerID', 'error');
        }

    }

    activateDeactivateClient(value) {
        let clientObject = '';
        let payerId = '';
        if (value) {
            payerId = this.reactivateClientForm.value['payerID']
        } else {
            payerId = this.deactivateClientForm.value['payerID']
        }
        if (payerId !== null) {
            this.showLoader = true;
            this.restCallingService.getClientPayerIdDetails(payerId).subscribe(
                data => {
                    clientObject = data.json();
                    this.restCallingService.activateOrDeactivateClient(this.getClientObject(clientObject, value)).subscribe(
                        resp => {
                            this.showLoader = false;
                            this.resetFormValues();
                            if (value) {
                                swal('Success!', 'Client Reactivated Successfully!', 'success');
                            } else {
                                swal('Success!', 'Client Deactivated Successfully!', 'success');
                            }
                        },
                        err => {
                            this.showLoader = false;
                            console.log(err.json());
                            swal('Failure', err.json().message,'error');
                        });
                }, err => {
                    this.showLoader = false;
                    console.log(err.json());
                    swal('Failure', err.json().message,'error');
                });
        } else {
            swal('Failure', 'Invalid PayerID', 'error');
        }
    }

    ClientListButtonClick() {
        if (this.clientList === null || this.clientList === undefined) {
            this.loadClient();
        }
        $('#clientManagementSection').slideToggle();
        $('.client-list-icon').toggleClass('fa-plus-circle fa-minus-circle');
    }

    deleteClient(client) {
        swal({ title: 'Are you sure?', text: 'Are you sure you want to delete ?', icon: 'warning', buttons: true }).then(
            (isConfirmed) => {
                if (isConfirmed) {
                    this.showLoader = true;
                    this.restCallingService.activateOrDeactivateClient(this.getClientObject(client, false)).subscribe(resp => {
                        this.showLoader = false;
                        swal('Success!', 'Client Deleted Successfully!', 'success').then(()=>{
                            this.loadClient();
                        });
                    }, err => {
                        this.showLoader = false;
                        swal('Failure!', err.json().message,'error');
                        console.log(err.json());
                    });
                };
            }
        );
    }

    filterClientList() {
        if (this.clientTableFilterValue === undefined) {
            return false;
        }
        if (this.clientTableFilterValue !== '' && this.clientList !== undefined) {
            this.filteredClientList = this.clientList.filter(function (el) {
                if (!el.name || !el.payerId)
                    return false;
                return el.name.toLowerCase().indexOf(this.clientTableFilterValue.toLowerCase()) >= 0 ||
                    el.payerId.toLowerCase().indexOf(this.clientTableFilterValue.toLowerCase()) >= 0 ||
                    el.emailId.toLowerCase().indexOf(this.clientTableFilterValue.toLowerCase()) >= 0 ||
                    el.city.toLowerCase().indexOf(this.clientTableFilterValue.toLowerCase()) >= 0 ||
                    el.state.toLowerCase().indexOf(this.clientTableFilterValue.toLowerCase()) >= 0;
            }.bind(this));
        } else {
            this.filteredClientList = this.clientList;
        }
    }

    //#endregion

    //#region Page Methods

    loadClient() {
        this.showLoader = true;
        this.restCallingService.getListofClientForInternalUser({}).subscribe(
            data => {
                this.showLoader = false;
                this.clientList = data.json();
                this.filteredClientList = data.json();
            }, err => {
                this.showLoader = false;
                console.log(err.json());
                swal('Failure', err.json().message,'error');
            }
        );
    }

    getClientObject(clientObj, value) {
        return {
            id: clientObj.id,
            payerId: clientObj.payerId,
            isActive: value
        };
    }

    resetFormValues() {
        this.clientList = null;
        this.addClientForm.reset();
        this.reactivateClientForm.reset();
        this.deactivateClientForm.reset();
        if ($('.client-list-icon').hasClass('fa-minus-circle')) {
            $('#clientManagementSection').slideUp();
            $('.client-list-icon').toggleClass('fa-plus-circle fa-minus-circle');
        }
    }

    exportCSV() {
        if (!this.clientList)
            return;
        if (this.clientList.length == 0) {
            swal('Error:', 'Table must contain at least one record to export.', 'warning');
            return;
        }

        for(var i = 0 ; i < this.clientList.length ; i++) {
            if(this.clientList[i]['emailOptIn'] == true) {
                this.clientList[i]['emailOptInDisplay'] = 'Yes'; 
            } else {
                this.clientList[i]['emailOptInDisplay'] = 'No'; 
            }

            if(this.clientList[i]['clientActive'] == true) {
                this.clientList[i]['clientActiveDisplay'] = 'Yes';  
            } else {
                this.clientList[i]['clientActiveDisplay'] = 'No';
            }
        }

        let data: any = [];
        let columnMap : Map<string,string> = new Map<string, string>();
        columnMap.set('payerId', 'Payer ID');
        columnMap.set('name', 'Client Name');
        columnMap.set('emailId', 'Email ID');
        columnMap.set('city', 'City') ;
        columnMap.set('state', 'State');
        columnMap.set('emailOptInDisplay', 'Email Settings');
        columnMap.set('clientActiveDisplay', 'Active');
        let columns: any = [];
        for (let colName of Array.from(columnMap.values())) {
            columns.push(colName);
        }
        data.push(columns);
        for(let row of this.clientList) {
            let record: any = [];
            for (let col of Array.from(columnMap.keys())) {
            record.push(row[col] || '');
            }
            data.push(record);
        }
        alasql.promise('SELECT * INTO CSV("CLIENT_LIST_EXPORT.CSV", {headers:false, separator:","\}) FROM ?', [data])
            .then(function () {
            console.log('Data saved');
            }).catch(function (err) {
            console.log('Error:', err);
            });
    }

    editSelectedRow(data) {
        for (const value in data) {
            if (this.updateClientForm.controls[value] !== undefined) {
                this.updateClientForm.controls[value].setValue(data[value]);
            }
        }
    }

    saveClientData() {
        this.showLoader = true;
        let clientObject = '';
        let payerId = this.updateClientForm.value['payerId'];
        
        this.restCallingService.getClientPayerIdDetails(payerId).subscribe(
            data => {
                clientObject = data.json();
                this.restCallingService.updateClientById(this.getUpdatedClientObject(clientObject, true)).subscribe(
                    resp => {
                        this.showLoader = false;
                        swal('Success!', 'Client Updated Successfully!', 'success');
                        $('#clientEditModal').modal('toggle');
                        this.loadClient();
                    },
                    err => {
                        console.log(err.json());
                        swal('Failure', err.json().message, 'error');
                    });
            }, err => {
                this.showLoader = false;
                console.log(err.json());
                swal('Failure', err.json().message, 'error');
            });

    }

    getUpdatedClientObject(clientObj, activeValue) {
        return {
            id: clientObj.id,
            payerId: clientObj.payerId,
            isActive: activeValue,
            emailOptIn: this.updateClientForm.controls['emailOptIn'].value,
            clientActive: this.updateClientForm.controls['clientActive'].value,
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./src/app/client-management/client-management.component.ts